import { StateInterface, User, RelationType } from "./types";

export default {
  setStateFromLocalStorage(state: StateInterface): void {
    const str = localStorage.getItem("loggedIn");
    state.loggedIn = str === "true";
  },
  setProfile(state: StateInterface, profile: User): void {
    state.profile = profile;
  },
  clearProfile(state: StateInterface): void {
    state.profile = {
      id: 0,
      representee_id: 0,
      first_name: "",
      last_name: "",
      organisation_name: "",
      email_address: "",
      relation_type: RelationType.private
    };
  }
};
